import { Component, Input } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { PlazzaService } from '../../services/plazza.service';

@Component({
  selector: 'app-store-carousel',
  templateUrl: './store-carousel.component.html',
  styleUrls: ['./store-carousel.component.scss']
})
export class StoreCarouselComponent{
  
  @Input('stores') stores: Array<any> = [];
  public config: SwiperConfigInterface = { };
  
  constructor(
    public plazzaService: PlazzaService
  ) { }

  ngAfterViewInit(){
    this.config = {
      slidesPerView: 7,
      spaceBetween: 10,         
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,  
      loop: true,
      preloadImages: false,
      lazy: true,     
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: "slide",
      breakpoints: {
        240: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 4
        },
        1280: {
          slidesPerView: 5
        },
        1500: {
          slidesPerView: 6
        }
      }
    }
  }

}
